var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B208"
    },
    d: "M248,408c-88.8,0-160-72-160-160S160,88,248,88s160,72,160,160S336.8,408,248,408z M248,159.2 c-48.8,0-88.8,40-88.8,88.8s40,88.8,88.8,88.8s88.8-40,88.8-88.8S296.8,159.2,248,159.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4840B"
    },
    cx: 248,
    cy: 22.4,
    r: 22.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7B208"
    },
    cx: 248,
    cy: 473.6,
    r: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4840B"
    },
    d: "M154.4,41.6c6.4,10.4,2.4,24-8,30.4s-24,2.4-30.4-8s-2.4-24,8-30.4C134.4,27.2,148,30.4,154.4,41.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7B208"
    },
    cx: 360.8,
    cy: 443.2,
    r: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B208"
    },
    d: "M64,116c10.4,6.4,14.4,20,8,30.4s-20,14.4-30.4,8s-14.4-20-8-30.4C39.2,113.6,52.8,109.6,64,116z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4840B"
    },
    cx: 443.2,
    cy: 360.8,
    r: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B208"
    },
    d: "M22.4,225.6c12,0,22.4,9.6,22.4,22.4c0,12-9.6,22.4-22.4,22.4S0,260,0,248S9.6,225.6,22.4,225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4840B"
    },
    d: "M473.6,225.6c12,0,22.4,9.6,22.4,22.4c0,12-9.6,22.4-22.4,22.4s-22.4-9.6-22.4-22.4 C451.2,236,461.6,225.6,473.6,225.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7B208"
    },
    cx: 52.8,
    cy: 360.8,
    r: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4840B"
    },
    d: "M432,116c10.4-6.4,24-2.4,30.4,8s2.4,24-8,30.4s-24,2.4-30.4-8C418.4,136,421.6,121.6,432,116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B208"
    },
    d: "M116,432c6.4-10.4,20-14.4,30.4-8s14.4,20,8,30.4s-20,14.4-30.4,8C113.6,456.8,109.6,443.2,116,432z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4840B"
    },
    d: "M341.6,41.6c6.4-10.4,20-14.4,30.4-8s14.4,20,8,30.4s-20,14.4-30.4,8S335.2,52,341.6,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4840B"
    },
    d: "M248,88c-51.2,0-96.8,24.8-126.4,62.4l51.2,51.2c16-24.8,44-41.6,75.2-41.6 c48.8,0,88.8,40,88.8,88.8c0,32-16.8,60-41.6,75.2l51.2,51.2C384,344.8,408,299.2,408,248C408,159.2,336.8,88,248,88z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.5f0b2f5301e58e37ac15ba1a79b3f3da.svg";
export { ForwardRef as ReactComponent };